import { useCallback, useSyncExternalStore } from "react";

/*
 * Settings pages (general, connectors, each connector setup wizard) are separate
 * routes, so per-page state would reset the rail to open on every navigation.
 * Keep the choice at module level so it holds for the whole session.
 */
let isCollapsed = false;
const listeners = new Set();

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

const getSnapshot = () => isCollapsed;

const toggle = () => {
  isCollapsed = !isCollapsed;
  listeners.forEach((listener) => listener());
};

/**
 * Settings rail open/closed state shared by every settings-style page.
 *
 * @example
 * const [isNavCollapsed, toggleNavCollapsed] = useSettingsNavCollapsed();
 * <BusinessAppSettingsChrome isNavCollapsed={isNavCollapsed} onToggleNav={toggleNavCollapsed} />
 *
 * @returns {[boolean, () => void]} Collapsed flag and a stable toggle.
 */
const useSettingsNavCollapsed = () => {
  const collapsed = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  return [collapsed, useCallback(toggle, [])];
};

export default useSettingsNavCollapsed;
